import { useState } from "react";

const FABRIC_DATA = {
  Suiting: {
    types: ["Plain"],
    designs: {
      Plain: Array.from({ length: 8 }, (_, i) => ({
        id: `suit-plain-${i + 1}`,
        name: `Design S${String(i + 1).padStart(2, "0")}`,
        images: Array.from({ length: 10 }, (_, j) => ({
          id: `img-s${i + 1}-${j + 1}`,
          url: `https://picsum.photos/seed/suit${i * 10 + j}/400/400`,
          label: `View ${j + 1}`,
        })),
        stock: {
          available: Math.floor(Math.random() * 200 + 50),
          unit: "meters",
          colors: ["Navy", "Charcoal", "Black", "Grey"][i % 4],
          weight: `${220 + i * 10}gsm`,
          composition: "65% Polyester, 35% Viscose",
          price: (Math.random() * 200 + 300).toFixed(2),
        },
      })),
    },
  },
  Shirting: {
    types: ["Print", "Plain"],
    designs: {
      Print: Array.from({ length: 20 }, (_, i) => ({
        id: `shirt-print-${i + 1}`,
        name: `Print P${String(i + 1).padStart(2, "0")}`,
        images: Array.from({ length: 10 }, (_, j) => ({
          id: `img-p${i + 1}-${j + 1}`,
          url: `https://picsum.photos/seed/print${i * 10 + j + 100}/400/400`,
          label: `View ${j + 1}`,
        })),
        stock: {
          available: Math.floor(Math.random() * 500 + 100),
          unit: "meters",
          colors: ["Multicolor", "Blue base", "Red base", "White base"][i % 4],
          weight: `${100 + i * 5}gsm`,
          composition: "100% Cotton",
          price: (Math.random() * 100 + 150).toFixed(2),
        },
      })),
      Plain: Array.from({ length: 15 }, (_, i) => ({
        id: `shirt-plain-${i + 1}`,
        name: `Plain PL${String(i + 1).padStart(2, "0")}`,
        images: Array.from({ length: 10 }, (_, j) => ({
          id: `img-pl${i + 1}-${j + 1}`,
          url: `https://picsum.photos/seed/plain${i * 10 + j + 300}/400/400`,
          label: `View ${j + 1}`,
        })),
        stock: {
          available: Math.floor(Math.random() * 300 + 80),
          unit: "meters",
          colors: ["White", "Sky Blue", "Pink", "Mint", "Yellow"][i % 5],
          weight: `${80 + i * 5}gsm`,
          composition: "100% Cotton",
          price: (Math.random() * 80 + 100).toFixed(2),
        },
      })),
    },
  },
};

function StepBar({ steps, current }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 0, marginBottom: 32 }}>
      {steps.map((s, i) => (
        <div key={s} style={{ display: "flex", alignItems: "center", flex: i < steps.length - 1 ? 1 : "none" }}>
          <div style={{
            width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center",
            justifyContent: "center", fontWeight: 700, fontSize: 13,
            background: i < current ? "#1a1a2e" : i === current ? "#e8b86d" : "#e5e5e5",
            color: i < current ? "#fff" : i === current ? "#1a1a2e" : "#999",
            flexShrink: 0, transition: "all .3s",
          }}>{i < current ? "✓" : i + 1}</div>
          <span style={{ marginLeft: 8, fontSize: 13, fontWeight: i === current ? 700 : 400, color: i === current ? "#1a1a2e" : "#999", whiteSpace: "nowrap" }}>{s}</span>
          {i < steps.length - 1 && (
            <div style={{ flex: 1, height: 2, background: i < current ? "#1a1a2e" : "#e5e5e5", margin: "0 12px", transition: "background .3s" }} />
          )}
        </div>
      ))}
    </div>
  );
}

function SelectCard({ label, sublabel, icon, selected, onClick }) {
  return (
    <div onClick={onClick} style={{
      border: `2px solid ${selected ? "#e8b86d" : "#e5e5e5"}`,
      borderRadius: 16, padding: "28px 32px", cursor: "pointer",
      background: selected ? "#fffbf2" : "#fff", transition: "all .2s", flex: 1, minWidth: 200,
      boxShadow: selected ? "0 4px 20px rgba(232,184,109,.25)" : "0 1px 4px rgba(0,0,0,.06)",
      display: "flex", flexDirection: "column", gap: 8,
    }}>
      <div style={{ fontSize: 36 }}>{icon}</div>
      <div style={{ fontWeight: 800, fontSize: 20, color: "#1a1a2e" }}>{label}</div>
      {sublabel && <div style={{ fontSize: 13, color: "#888" }}>{sublabel}</div>}
      {selected && <div style={{ marginTop: 4, fontSize: 12, color: "#e8b86d", fontWeight: 700 }}>✓ Selected</div>}
    </div>
  );
}

function DesignGrid({ designs, selectedId, onSelect }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 16 }}>
      {designs.map((d) => (
        <div key={d.id} onClick={() => onSelect(d)} style={{
          border: `2px solid ${selectedId === d.id ? "#e8b86d" : "#e5e5e5"}`,
          borderRadius: 12, overflow: "hidden", cursor: "pointer",
          background: selectedId === d.id ? "#fffbf2" : "#fff", transition: "all .2s",
          boxShadow: selectedId === d.id ? "0 4px 16px rgba(232,184,109,.3)" : "0 1px 4px rgba(0,0,0,.06)",
        }}>
          <img src={d.images[0].url} alt={d.name} style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block" }} />
          <div style={{ padding: "10px 12px" }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1a2e" }}>{d.name}</div>
            <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{d.stock.colors} · {d.stock.weight}</div>
            {selectedId === d.id && <div style={{ fontSize: 11, color: "#e8b86d", fontWeight: 700, marginTop: 4 }}>✓ Selected</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

function ImageGallery({ design, selectedImages, onToggle }) {
  return (
    <div>
      <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontWeight: 700, fontSize: 16, color: "#1a1a2e" }}>{design.name} — Select Images</div>
        <div style={{ fontSize: 13, color: "#888" }}>{selectedImages.length} / {design.images.length} selected</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: 12 }}>
        {design.images.map((img) => {
          const sel = selectedImages.includes(img.id);
          return (
            <div key={img.id} onClick={() => onToggle(img.id)} style={{
              border: `2px solid ${sel ? "#e8b86d" : "#e5e5e5"}`,
              borderRadius: 10, overflow: "hidden", cursor: "pointer",
              position: "relative", transition: "all .2s",
              boxShadow: sel ? "0 2px 12px rgba(232,184,109,.3)" : "none",
            }}>
              <img src={img.url} alt={img.label} style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block" }} />
              {sel && (
                <div style={{
                  position: "absolute", top: 6, right: 6, width: 22, height: 22,
                  background: "#e8b86d", borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 12, fontWeight: 800, color: "#1a1a2e",
                }}>✓</div>
              )}
              <div style={{ padding: "6px 8px", fontSize: 11, color: "#666", fontWeight: 500 }}>{img.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function StockCard({ stock, designName }) {
  const rows = [
    ["Design", designName],
    ["Available Stock", `${stock.available} ${stock.unit}`],
    ["Color", stock.colors],
    ["Weight", stock.weight],
    ["Composition", stock.composition],
    ["Price / meter", `₹ ${stock.price}`],
  ];
  return (
    <div style={{ background: "#f8f8f8", borderRadius: 14, padding: 20, border: "1px solid #eee" }}>
      <div style={{ fontWeight: 800, fontSize: 15, color: "#1a1a2e", marginBottom: 14 }}>📋 Stock Details</div>
      {rows.map(([k, v]) => (
        <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #eee", fontSize: 14 }}>
          <span style={{ color: "#888" }}>{k}</span>
          <span style={{ fontWeight: 600, color: "#1a1a2e" }}>{v}</span>
        </div>
      ))}
    </div>
  );
}

function generatePDFContent(selection) {
  const { category, type, design, selectedImages } = selection;
  const images = design.images.filter((img) => selectedImages.includes(img.id));
  const s = design.stock;
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"/><title>Fabric Catalogue — ${design.name}</title><style>@page{margin:20mm;size:A4}*{box-sizing:border-box;margin:0;padding:0}body{font-family:Georgia,serif;color:#1a1a2e}.header{background:#1a1a2e;color:#e8b86d;padding:24px 32px;display:flex;justify-content:space-between;align-items:center}.header h1{font-size:24px;letter-spacing:2px}.header .sub{font-size:12px;color:#aaa;margin-top:4px}.badge{background:#e8b86d;color:#1a1a2e;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:700}.section{padding:24px 32px}h2{font-size:16px;color:#1a1a2e;margin-bottom:16px;border-bottom:2px solid #e8b86d;padding-bottom:8px}table{width:100%;border-collapse:collapse;font-size:13px}td{padding:9px 12px;border-bottom:1px solid #eee}td:first-child{color:#888;width:40%}td:last-child{font-weight:700}.img-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-top:8px}.img-wrap{border:1px solid #eee;border-radius:8px;overflow:hidden}.img-wrap img{width:100%;aspect-ratio:1;object-fit:cover;display:block}.img-label{font-size:10px;text-align:center;color:#888;padding:4px}.footer{margin-top:32px;padding:16px 32px;background:#f8f8f8;font-size:11px;color:#aaa;display:flex;justify-content:space-between}.highlight{background:#fffbf2;border:1px solid #e8b86d;border-radius:8px;padding:12px 16px;margin-bottom:16px}</style></head><body><div class="header"><div><h1>FABRIC CATALOGUE</h1><div class="sub">Generated on ${new Date().toLocaleDateString("en-IN",{day:"2-digit",month:"long",year:"numeric"})}</div></div><span class="badge">${category} · ${type}</span></div><div class="section"><h2>STOCK DETAILS</h2><div class="highlight"><table><tr><td>Design Name</td><td>${design.name}</td></tr><tr><td>Category</td><td>${category}</td></tr><tr><td>Type</td><td>${type}</td></tr><tr><td>Available Stock</td><td>${s.available} ${s.unit}</td></tr><tr><td>Color</td><td>${s.colors}</td></tr><tr><td>Weight</td><td>${s.weight}</td></tr><tr><td>Composition</td><td>${s.composition}</td></tr><tr><td>Price / Meter</td><td>₹ ${s.price}</td></tr><tr><td>Images in Catalogue</td><td>${images.length}</td></tr></table></div></div><div class="section"><h2>SELECTED IMAGES (${images.length})</h2><div class="img-grid">${images.map((img)=>`<div class="img-wrap"><img src="${img.url}" alt="${img.label}" crossorigin="anonymous"/><div class="img-label">${img.label}</div></div>`).join("")}</div></div><div class="footer"><span>Confidential — For Trade Use Only</span><span>${design.name} | ${category} ${type}</span></div></body></html>`;
}

function SummaryScreen({ selection, onBack, onReset }) {
  const { category, type, design, selectedImages } = selection;
  const images = design.images.filter((img) => selectedImages.includes(img.id));
  const [pdfOpen, setPdfOpen] = useState(false);

  const handleGeneratePDF = () => {
    const html = generatePDFContent(selection);
    const win = window.open("", "_blank");
    if (win) {
      win.document.write(html);
      win.document.close();
      setTimeout(() => { win.focus(); win.print(); }, 500);
      setPdfOpen(true);
    }
  };

  return (
    <div>
      <div style={{ background: "#1a1a2e", borderRadius: 16, padding: "24px 28px", color: "#fff", marginBottom: 24 }}>
        <div style={{ fontSize: 12, color: "#e8b86d", fontWeight: 700, letterSpacing: 2, marginBottom: 6 }}>SELECTION COMPLETE</div>
        <div style={{ fontSize: 22, fontWeight: 800 }}>{design.name}</div>
        <div style={{ fontSize: 14, color: "#aaa", marginTop: 4 }}>{category} · {type} · {images.length} images selected</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 24 }}>
        <StockCard stock={design.stock} designName={design.name} />
        <div>
          <div style={{ fontWeight: 700, fontSize: 15, color: "#1a1a2e", marginBottom: 12 }}>🖼️ Selected Images ({images.length})</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8 }}>
            {images.map((img) => (
              <div key={img.id} style={{ borderRadius: 8, overflow: "hidden", border: "1px solid #eee" }}>
                <img src={img.url} alt={img.label} style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block" }} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button onClick={onBack} style={{ padding: "12px 24px", borderRadius: 10, border: "2px solid #e5e5e5", background: "#fff", color: "#1a1a2e", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>← Back</button>
        <button onClick={handleGeneratePDF} style={{ padding: "12px 28px", borderRadius: 10, border: "none", background: "#e8b86d", color: "#1a1a2e", fontWeight: 800, cursor: "pointer", fontSize: 15, display: "flex", alignItems: "center", gap: 8, boxShadow: "0 4px 16px rgba(232,184,109,.4)" }}>📄 Generate & Download PDF</button>
        <button onClick={onReset} style={{ padding: "12px 24px", borderRadius: 10, border: "2px solid #1a1a2e", background: "#1a1a2e", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>↺ Start New Selection</button>
      </div>
      {pdfOpen && <div style={{ marginTop: 16, padding: "12px 16px", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 10, fontSize: 13, color: "#166534" }}>✅ PDF catalogue opened in a new tab with print dialog.</div>}
    </div>
  );
}

export default function FabricSelector() {
  const [step, setStep] = useState(0);
  const [category, setCategory] = useState(null);
  const [type, setType] = useState(null);
  const [design, setDesign] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const STEPS = ["Category", "Type", "Design", "Images", "Summary"];
  const reset = () => { setStep(0); setCategory(null); setType(null); setDesign(null); setSelectedImages([]); };
  const toggleImage = (id) => setSelectedImages((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  const canNext = () => {
    if (step === 0) return !!category;
    if (step === 1) return !!type;
    if (step === 2) return !!design;
    if (step === 3) return true;
    return false;
  };
  const handleNext = () => {
    if (step === 3 && selectedImages.length === 0) setSelectedImages(design.images.map((i) => i.id));
    setStep((s) => s + 1);
  };
  const currentTypes = category ? FABRIC_DATA[category]?.types || [] : [];
  const currentDesigns = (category && type) ? FABRIC_DATA[category]?.designs[type] || [] : [];

  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5", fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: "#1a1a2e", padding: "0 32px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22 }}>🧵</span>
          <span style={{ color: "#e8b86d", fontWeight: 800, fontSize: 18, letterSpacing: 1 }}>FABRIC SELECTOR</span>
        </div>
        {step > 0 && <button onClick={reset} style={{ background: "transparent", border: "1px solid #555", color: "#aaa", borderRadius: 8, padding: "6px 14px", cursor: "pointer", fontSize: 13 }}>↺ Reset</button>}
      </div>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "32px 20px" }}>
        <StepBar steps={STEPS} current={step} />
        {step === 0 && (
          <div>
            <div style={{ fontWeight: 800, fontSize: 22, color: "#1a1a2e", marginBottom: 8 }}>Select Fabric Category</div>
            <div style={{ color: "#888", marginBottom: 24, fontSize: 14 }}>Choose between Suiting or Shirting fabric lines.</div>
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
              <SelectCard label="Suiting" sublabel="Premium suiting fabrics" icon="🧥" selected={category === "Suiting"} onClick={() => setCategory("Suiting")} />
              <SelectCard label="Shirting" sublabel="Print & plain shirting" icon="👔" selected={category === "Shirting"} onClick={() => setCategory("Shirting")} />
            </div>
          </div>
        )}
        {step === 1 && (
          <div>
            <div style={{ fontWeight: 800, fontSize: 22, color: "#1a1a2e", marginBottom: 8 }}>Select Fabric Type</div>
            <div style={{ color: "#888", marginBottom: 24, fontSize: 14 }}>Choose the type under <b>{category}</b>.</div>
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
              {currentTypes.map((t) => (
                <SelectCard key={t} label={t} sublabel={`${FABRIC_DATA[category].designs[t].length} designs available`} icon={t === "Print" ? "🎨" : "⬜"} selected={type === t} onClick={() => setType(t)} />
              ))}
            </div>
          </div>
        )}
        {step === 2 && (
          <div>
            <div style={{ fontWeight: 800, fontSize: 22, color: "#1a1a2e", marginBottom: 8 }}>Select Design</div>
            <div style={{ color: "#888", marginBottom: 24, fontSize: 14 }}>{currentDesigns.length} designs under <b>{category} {type}</b>.</div>
            <DesignGrid designs={currentDesigns} selectedId={design?.id} onSelect={setDesign} />
          </div>
        )}
        {step === 3 && design && (
          <div>
            <div style={{ fontWeight: 800, fontSize: 22, color: "#1a1a2e", marginBottom: 4 }}>Select Images for PDF</div>
            <div style={{ color: "#888", marginBottom: 24, fontSize: 14 }}>Leave all unselected to include all 10 images.</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 300px", gap: 24, alignItems: "start" }}>
              <ImageGallery design={design} selectedImages={selectedImages} onToggle={toggleImage} />
              <div style={{ position: "sticky", top: 20 }}>
                <StockCard stock={design.stock} designName={design.name} />
              </div>
            </div>
          </div>
        )}
        {step === 4 && design && (
          <SummaryScreen
            selection={{ category, type, design, selectedImages: selectedImages.length > 0 ? selectedImages : design.images.map((i) => i.id) }}
            onBack={() => setStep(3)} onReset={reset}
          />
        )}
        {step < 4 && (
          <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
            {step > 0 ? <button onClick={() => setStep((s) => s - 1)} style={{ padding: "12px 24px", borderRadius: 10, border: "2px solid #e5e5e5", background: "#fff", color: "#1a1a2e", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>← Back</button> : <div />}
            <button disabled={!canNext()} onClick={handleNext} style={{ padding: "12px 32px", borderRadius: 10, border: "none", background: canNext() ? "#1a1a2e" : "#e5e5e5", color: canNext() ? "#fff" : "#aaa", fontWeight: 800, cursor: canNext() ? "pointer" : "default", fontSize: 15, transition: "all .2s" }}>
              {step === 3 ? "Review & Generate PDF →" : "Next →"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
